import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withSiteData, withRouteData } from 'react-static';
import onClickOutside from 'react-onclickoutside';
import { injectIntl, intlShape } from 'react-intl';

import { SUPPORTED_LANGUAGES } from '../../../locales';
import { getUrlWithStickyParams } from '../../../util';
import { commonMessages } from '../../../messages/commonMessages';
import { type } from '../../../styles/typography';
import chevron from '../../../assets/images/home/chevron.svg';

const Wrapper = styled.div`
  position: relative;
`;

const Toggle = styled.button`
  ${type('label', 'small', { uppercase: true })};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 15px;
  border-radius: var(--b-radius-s);
  background-color: var(--b-graphite);
  color: var(--b-white);
  transition: background-color 0.16s ease;

  &:hover {
    background-color: #3a3c3b;
  }

  img {
    width: 6px;
    height: 11px;
    transform: rotate(90deg);
    transition: transform 0.16s ease;
  }

  &[aria-expanded='true'] img {
    transform: rotate(-90deg);
  }
`;

const List = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 100%;
  padding: 4px 0;
  border-radius: var(--b-radius-s);
  background-color: var(--b-graphite);
  z-index: 5;

  li {
    list-style: none;
  }

  button {
    ${type('label', 'small', { uppercase: true })};
    display: block;
    width: 100%;
    padding: 8px 15px;
    color: rgba(255, 255, 255, 0.72);
    text-align: left;

    &:hover {
      background-color: var(--b-white);
      color: var(--b-black);
    }
  }
`;

class LanguageSelector extends React.Component {
  state = {
    isOpen: false,
  };

  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  onChange = value => () => {
    const { pathWithoutBasename } = this.props;
    const targetPath = pathWithoutBasename !== '/' ? pathWithoutBasename : '';
    window.location = getUrlWithStickyParams(`/${targetPath}`, value === 'en' ? '' : value);
    this.setState({ isOpen: false });
  };

  render() {
    const { intl, language, className } = this.props;
    const { isOpen } = this.state;

    return (
      <Wrapper className={className}>
        <Toggle
          onClick={this.onToggle}
          aria-expanded={isOpen}
          aria-controls="language-selector-list"
          aria-label={intl.formatMessage(commonMessages.currentLanguage, { lang: language })}
        >
          {language}
          <img src={chevron} alt="" />
        </Toggle>
        {isOpen && (
          <List id="language-selector-list">
            {SUPPORTED_LANGUAGES.filter(langKey => langKey !== language).map(langKey => (
              <li key={langKey}>
                <button
                  onClick={this.onChange(langKey)}
                  aria-label={intl.formatMessage(commonMessages.changeLanguage, { lang: langKey })}
                >
                  {langKey}
                </button>
              </li>
            ))}
          </List>
        )}
      </Wrapper>
    );
  }

  handleClickOutside = () => {
    this.setState({ isOpen: false });
  };
}

LanguageSelector.propTypes = {
  language: PropTypes.string.isRequired,
  pathWithoutBasename: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  className: PropTypes.string,
};

export default withSiteData(withRouteData(injectIntl(onClickOutside(LanguageSelector))));



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/header/LanguageSelector.js